import { render, staticRenderFns } from "./CIDSummary.vue?vue&type=template&id=f99e0e3e&scoped=true"
import script from "./CIDSummary.vue?vue&type=script&lang=js"
export * from "./CIDSummary.vue?vue&type=script&lang=js"
import style0 from "./CIDSummary.vue?vue&type=style&index=0&id=f99e0e3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99e0e3e",
  null
  
)

export default component.exports